/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import crownV2 from "assets/crownV2.png";
import { getFlexBasis } from "components/DIP/lib/helper";
import { useStickyDIPAction } from "components/StickyDIP/hooks/useStickyDipAction";
import { IShopPurchaseOffer } from "contexts/WebStoreProvider/types";
import { useAppSelector } from "hooks";
import { DipButton } from "interfaces";
import { Fragment } from "react";
import { selectWebStoreState } from "redux/slices";
import { getDisplayRewards } from "helpers/getDisplayRewards";
import {
	Container,
	CrossOutValue,
	CustomButtom,
	DataContainer,
	InfoContainer,
	ItemImage,
	Items,
	LoyaltyContainer,
	LoyaltyPoints,
	OfferItem,
	RewardAmount,
	RewardItem,
	SubTitle
} from "./styles";
import { sortBundleRewards } from "helpers/rewardSort";

interface OffersProps {
	data: Omit<
		IShopPurchaseOffer,
		"onlyNonPayers" | "priority" | "purchaseButtonBannerText" | "bannerText"
	>[];
}

export const CountdownOffer: React.FC<OffersProps> = ({
	data
}: OffersProps) => {
	const isLowWidth = useMediaQuery("(max-width:733px)");
	const isMobile = isLowWidth;
	const { rewards, rewardTypes } = useAppSelector(selectWebStoreState).store;
	const { onStickyAction } = useStickyDIPAction();
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty messaging.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	//const arrayTest = [1, 2, 3, 4, 5, 6];

	return (
		<Container>
			<DataContainer>
				{data?.map(
					(
						{ rewardId, price, loyaltyPointReward, loyaltyPointCrossout, id },
						key
					) => {
						const items = getDisplayRewards(rewardId, {
							rewards,
							rewardTypes
						});
						return (
							<Fragment key={id}>
								<OfferItem>
									<Items>
										{sortBundleRewards(items).map(
											({ imageUrl, description }, key) => {
												const flexBasis = getFlexBasis(
													data as unknown as DipButton[],
													items,
													isMobile
												);

												return (
													<RewardItem key={key} width={flexBasis + "%"}>
														<ItemImage src={imageUrl} alt="" />
														<RewardAmount style={{ paintOrder: "stroke fill" }}>
															{description}
														</RewardAmount>
													</RewardItem>
												);
											}
										)}

										{/* {arrayTest.map(({}, key) => {
										const flexBasis = getFlexBasis(
											data as unknown as DipButton[],
											items,
											isMobile
										);
										return (
											<RewardItem key={key} width={flexBasis + "%"}>
												<ItemImage
													src={
														"https://cdn-a1.tripeaksapp.com/WebStore/reward_images/coin.png"
													}
													alt=""
												/>

												<RewardAmount>{2000}</RewardAmount>
											</RewardItem>
										);
									})} */}
									</Items>
								</OfferItem>
								<SubTitle style={{ paintOrder: "stroke fill" }}>
									You also get:
								</SubTitle>
								<LoyaltyContainer>
									<ItemImage className="crown" src={crownV2} />
									<InfoContainer>
										{loyaltyPointCrossout && (
											<CrossOutValue>
												{Number(loyaltyPointCrossout)?.toLocaleString("en-US")}
											</CrossOutValue>
										)}
										<LoyaltyPoints style={{ paintOrder: "stroke fill" }}>
											{loyaltyPointReward?.toLocaleString("en-US")} Loyalty
											Points
										</LoyaltyPoints>
										{/*
											{isPoisActive && (
												<PoisBounty style={{ paintOrder: "stroke fill" }}>
													Contribute to Poi’s Bounty
												</PoisBounty>
											)}
										*/}
									</InfoContainer>
									{/* <InfoButton
									src={infoIcon}
									//onClick={() => openInfoPopup()}
								></InfoButton> */}
								</LoyaltyContainer>
								<CustomButtom
									variant="contained"
									color="success"
									size="large"
									onClick={() => {
										onStickyAction(id, rewardId, price);
									}}
								>
									{price.toString()} USD
								</CustomButtom>
							</Fragment>
						);
					}
				)}
			</DataContainer>
		</Container>
	);
};
